<template>
    <div>
        <v-container fluid>
            <v-row class="p-3">
                <v-col
                        v-for="(image,index) in img"
                        :key="image.id"
                        cols="12"
                        class="mx-auto my-2 card boxStyle"
                        md="2"
                        :data-img="image.id"
                >
                    <v-checkbox
                            v-model="selectedImage"
                            color="indigo"
                            :value="image.value"
                            hide-details
                    ></v-checkbox>
                    <img :src="image.full_path" class="img-fluid"
                         :key="image.id">
                    <p class="text-center my-0 pt-2">{{ image.name }}</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "officeType",
    data() {
        return {
            selectedImage: [],
            img: [
                {
                    id: '1',
                    name: 'دفترچه یادداشت',
                    value: 'notebook',
                    full_path: require('../../../../../public/media/site/Untitled-3.png')
                },
                {
                    id: '2',
                    name: 'سربرگ',
                    value: 'header',
                    full_path: require('../../../../../public/media/site/سربرگ.png')
                },
                {
                    id: '3',
                    name: 'کارت ویزیت',
                    value: 'visitCard',
                    full_path: require('../../../../../public/media/site/گارت-ویزیت.png')
                },
                {
                    id: '4',
                    name: 'پاکت نامه',
                    value: 'letter',
                    full_path: require('../../../../../public/media/site/پاکت-نامه1.png')
                },
                {
                    id: '5',
                    name: 'فولدر',
                    value: 'foolder',
                    full_path: require('../../../../../public/media/site/فولدر.png')
                },
            ],
            count: 1,
        }
    },
    watch:{
        selectedImage() {
            // this.$emit('persianName',this.img.find((x)=>x.value === this.selectedImage).name,"officeType")
            this.$emit('input', this.selectedImage)
        }
    }
}
</script>

<style scoped>

</style>